<template>
  <table class="same-table" cellspacing="0" cellpadding="0">
    <tr>
      <td rowspan="3" style="width: 100px">
        <div class="icon-content">
          <i class="el-icon-s-order icon-font-size"></i>
          <label>{{ obj.className }}</label>
        </div>
      </td>
      <td class="td-item-warp1">
        <div class="td-item">
          <div>{{ sameTitle.current.today }}</div>
          <div class="td-item-num">{{ obj.currentDayValue | toFixed }}</div>
          <div>{{ unit }}</div>
        </div>
      </td>
      <td class="td-item-warp1">
        <div class="td-item">
          <div>{{ sameTitle.current.thisMonth }}</div>
          <div class="td-item-num">{{ obj.currentMonthValue | toFixed }}</div>
          <div>{{ unit }}</div>
        </div>
      </td>
      <td class="td-item-warp1">
        <div class="td-item">
          <div>{{ sameTitle.current.thisYear }}</div>
          <div class="td-item-num">{{ obj.currentYearValue | toFixed }}</div>
          <div>{{ unit }}</div>
        </div>
      </td>
    </tr>
    <tr>
      <td class="td-item-warp">
        <div class="td-item">
          <div>{{ sameTitle.prev.today }}</div>
          <div class="td-item-num">{{ obj.lastDayValue | toFixed }}</div>
          <div>{{ unit }}</div>
        </div>
      </td>
      <td class="td-item-warp">
        <div class="td-item">
          <div>{{ sameTitle.prev.thisMonth }}</div>
          <div class="td-item-num">{{ obj.lastMonthValue | toFixed }}</div>
          <div>{{ unit }}</div>
        </div>
      </td>
      <td class="td-item-warp">
        <div class="td-item"  v-show="type=='hq'">
          <div>{{ sameTitle.prev.thisYear }}</div>
          <div class="td-item-num">{{ obj.lastYearValue | toFixed }}</div>
          <div>{{ unit }}</div>
        </div>
      </td>
    </tr>
    <tr>
      <td class="td-item-warp">
        <div class="td-item">
          <div>趋势</div>
          <div class="td-item-num">{{ obj.dayRatio | toFixed }}%</div>
        </div>
      </td>
      <td class="td-item-warp">
        <div class="td-item">
          <div>趋势</div>
          <div class="td-item-num">{{ obj.monthRatio | toFixed }}%</div>
        </div>
      </td>
      <td class="td-item-warp">
        <div class="td-item">
          <div>趋势</div>
          <div class="td-item-num">{{ obj.yearRatio | toFixed }}%</div>
        </div>
      </td>
    </tr>
  </table>
</template>

<script>
export default {
  props: {
    obj: {
      type: Object,
      default() {
        return {};
      },
    },
    sameTitle: {
      type: Object,
      default() {
        return {};
      },
    },
    unit: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
  },
  data() {
      return {
      }
  },
  filters: {
    toFixed(val) {
      if (!(+val)) return val;
      return (+val).toFixed(2)
    }
  },
};
</script>


<style lang="scss" scoped>
.same-table {
  width: 100%;
  color: #000;
  border-right: 1px solid #dbdada;
  border-bottom: 1px solid #dbdada;
  td {
    border-left: 1px solid #dbdada;
    border-top: 1px solid #dbdada;
  }
  .td-item-warp1 {
    width: calc(33.3% - 34px);
  }
  .td-item-warp {
    width: 33.3%;
  }
  .icon-content {
    width: 100px;
    display: flex;
    flex-flow: column;
    .icon-font-size {
      font-size: 30px;
    }
  }

  .td-item {
    display: flex;
    padding: 6px 10px;
    .td-item-num {
      flex: 1;
      text-align: right;
    }
  }
}
</style>